var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H22.2681V15.9058H0V0Z",
    fill: "url(#paint0_linear_54_12318)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.42285H22.2681V15.9059H0V7.42285Z",
    fill: "url(#paint1_linear_54_12318)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H22.2681V7.4227H0V0Z",
    fill: "url(#paint2_linear_54_12318)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H7.4227V7.4227H0V0Z",
    fill: "url(#paint3_linear_54_12318)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71229 4.53869L2.46573 5.42733L2.92567 3.96718L1.69531 3.05624L3.22613 3.04245L3.71229 1.59082L4.19845 3.04245L5.72926 3.05624L4.49891 3.96718L4.95885 5.42733L3.71229 4.53869Z",
    fill: "url(#paint4_linear_54_12318)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_54_12318",
    x1: 233.815,
    y1: 0,
    x2: 233.815,
    y2: 238.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_54_12318",
    x1: 233.815,
    y1: 7.42285,
    x2: 233.815,
    y2: 134.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA3B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D52B1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_54_12318",
    x1: 233.815,
    y1: 0,
    x2: 233.815,
    y2: 111.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_54_12318",
    x1: 77.9384,
    y1: 0,
    x2: 77.9384,
    y2: 111.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B48C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0239A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_54_12318",
    x1: 44.0518,
    y1: 1.59082,
    x2: 44.0518,
    y2: 59.1385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChile);
export default __webpack_public_path__ + "static/media/chile.93430caf3f0d52f659902a9ea1d243f5.svg";
export { ForwardRef as ReactComponent };